"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var CardRowSelectEditor = /** @class */ (function (_super) {
    __extends(CardRowSelectEditor, _super);
    function CardRowSelectEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.GRID_CARD_CSS = { width: '100%', textAlign: 'center', boxShadow: "none", padding: "10px" };
        return _this;
    }
    CardRowSelectEditor.prototype.onValueChange = function (value, option) {
        if (this.props.onValueChanged) {
            if (this.props.floatKey) {
                this.props.onValueChanged({ key: parseFloat(value.key), value: value.label.toString() });
            }
            else {
                this.props.onValueChanged({ key: parseInt(value.key), value: value.label.toString() });
            }
        }
    };
    CardRowSelectEditor.prototype.getSelectItems = function () {
        var _ret = [];
        for (var i = 0; i < this.props.items.length; i++) {
            _ret.push(React.createElement(antd_1.Select.Option, { key: "" + i, value: "" + this.props.items[i].key }, this.props.items[i].value));
        }
        return _ret;
    };
    CardRowSelectEditor.prototype.getRequiredMark = function () {
        if (this.props.required) {
            return (React.createElement("span", { style: { color: "#FF0000", marginRight: "2px" } }, "*"));
        }
        return (null);
    };
    CardRowSelectEditor.prototype.getErrorMessage = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return (React.createElement("div", { style: { color: "#FF0000", fontSize: "10px", textAlign: "left" } }, this.props.rules.errorMessage));
            }
        }
        return null;
    };
    CardRowSelectEditor.prototype.getTitleStyle = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return {
                    width: "224px",
                    maxWidth: "224px",
                    height: "34px",
                    color: "rgba(0,0,0,.65)",
                    textAlign: "center",
                    borderTopLeftRadius: "4px",
                    borderBottomLeftRadius: "4px",
                    backgroundColor: "#fafafa",
                    borderWidth: "1px",
                    borderRightWidth: "0px",
                    borderStyle: "solid",
                    borderColor: "#FF0000",
                    fontSize: "14px",
                    fontWeight: 400,
                    lineHeight: "33px"
                };
            }
        }
        return {
            width: "224px",
            maxWidth: "224px",
            height: "32px",
            color: "rgba(0,0,0,.65)",
            textAlign: "center",
            borderTopLeftRadius: "4px",
            borderBottomLeftRadius: "4px",
            backgroundColor: "#fafafa",
            borderWidth: "1px",
            borderRightWidth: "0px",
            borderStyle: "solid",
            borderColor: "#d9d9d9",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "31px"
        };
    };
    CardRowSelectEditor.prototype.getCSSStyle = function () {
        if (this.props.rules) {
            if (this.props.rules.isError) {
                return {
                    width: "calc( 100% - 226px )",
                    height: "34px",
                    borderColor: "#FF0000",
                    borderStyle: "solid",
                    borderWidth: "1px",
                    borderLeftWidth: "0px",
                    borderRadius: "4px",
                    borderBottomLeftRadius: 0,
                    borderTopLeftRadius: 0
                };
            }
        }
        return {
            width: "calc( 100% - 226px )",
            height: "34px"
        };
    };
    CardRowSelectEditor.prototype.getValue = function () {
        if (this.props.allowZeroKey) {
            if (this.props.value.key === 0) {
                return {
                    key: this.props.value.key.toString(),
                    label: this.props.value.value
                };
            }
        }
        if (this.props.value.key === 0) {
            return undefined;
        }
        else {
            return {
                key: this.props.value.key.toString(),
                label: this.props.value.value
            };
        }
    };
    CardRowSelectEditor.prototype.render = function () {
        return (React.createElement(antd_1.Card.Grid, { style: this.GRID_CARD_CSS },
            React.createElement("div", { style: { display: "flex", flexDirection: "column", justifyContent: "flex-start", alignItems: "flex-start", flexWrap: "nowrap" } },
                React.createElement(antd_1.Input.Group, { compact: true },
                    React.createElement("div", { style: this.getTitleStyle() },
                        React.createElement("div", null,
                            this.getRequiredMark(),
                            this.props.texts.caption)),
                    React.createElement(antd_1.Select, { showSearch: true, disabled: this.props.disabled, style: this.getCSSStyle(), placeholder: this.props.texts.placeholder, optionFilterProp: "children", filterOption: function (input, option) {
                            return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        }, onChange: this.onValueChange.bind(this), labelInValue: true, value: this.getValue() }, this.getSelectItems())),
                this.getErrorMessage())));
    };
    return CardRowSelectEditor;
}(React.Component));
exports.default = CardRowSelectEditor;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/editors/CardRowSelectEditor.tsx
// module id = 15
// module chunks = 0